const contentLegalPages = {
  cookiePolicy: {
    href: '/stranky/zasady-pouzivani-souboru-cookies',
    name: 'Zásady používání souboru cookies',
  },
  privacyPolicy: {
    href: '/stranky/zasady-ochrany-osobnich-udaju',
    name: 'Zásady ochrany osobních údajů',
  },
  safetyInformation: {
    href: '/stranky/bezpecnostni-informace',
    name: 'Bezpečnostní informace',
  },
  termsAndConditions: {
    href: '/stranky/obchodni-podminky',
    name: 'Obchodní podmínky',
  },
} as const;

export default contentLegalPages;
